module.exports = __webpack_public_path__ + "img/hamburgenergie-logo@2x.dcaae70a.webp";